import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, Button } from "react-bootstrap";
import validate from "validate.js";
import { setupProgramForTracking } from "actions";

const schema = {
  special_instructions: {},
};

const SpecialInstTab = ({ programDetails }) => {

  const dispatch = useDispatch();
  
  const session = useSelector((s) => s.session);
  const object_viewed_id = session?.current_page_permissions?.object_id || "";

  const [formState, setFormState] = useState({
    isValid: false,
    values: {
      special_instructions: "",
      object_viewed_id: object_viewed_id,
      program_id: programDetails?.id || "",
    },
    touched: {},
    errors: {},
  });

  useEffect(() => {
    const errors = validate(formState.values, schema);
    setFormState((formState) => ({
      ...formState,
      isValid: !errors,
      errors: errors || {},
    }));
  }, [formState.values]);

  useEffect(() => {
    if (programDetails?.special_instructions) {
      setFormState((formState) => ({
        ...formState,
        values: {
          ...formState.values,
          special_instructions: programDetails.special_instructions,
        },
        isValid: false, // Reset dirty state when new details are loaded
      }));
    }
  }, [programDetails]);

  const handleChange = (event) => {
    event.persist();
    setFormState((formState) => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]: event.target.value,
      },
      touched: {
        ...formState.touched,
        [event.target.name]: true,
      },
      isValid: true,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (formState.isValid ) {

      let data = formState.values;
      var onClose = () => {};
      dispatch( setupProgramForTracking(data, onClose) );
      //setFormState((formState) => ({ ...formState, isValid: false }));
    }
  };

  const hasError = (field) =>
    formState.touched[field] && formState.errors[field] ? true : false;

  return (
    <div className="p-3">
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-4">
          <Form.Label className="label-input">Special Instructions</Form.Label>
          <Form.Control
            as="textarea"
            rows={4}
            name="special_instructions"
            placeholder="Type your special instructions here..."
            value={formState.values.special_instructions}
            onChange={handleChange}
            isInvalid={hasError("special_instructions")}
            style={{
              borderRadius: "10px",
              border: "1px solid #ced4da",
              padding: "22px",
              fontSize: "12px",
              fontWeight: "600",
              color: "#617973",
              minHeight: "120px",
              resize: "vertical",
            }}
          />
          <Form.Control.Feedback type="invalid">
            {hasError("special_instructions")
              ? formState.errors.special_instructions[0]
              : null}
          </Form.Control.Feedback>
        </Form.Group>
        <div className="d-flex align-items-center gap-3">
          <button className="save-btn" type="submit" variant="none" disabled={!formState.isValid} >
            <img
              className="me-2 add-user-icon"
              src="/assets/images/save-tick-icon.svg"
              alt="Save"
            />
            Save Changes
          </button>
        </div>
      </Form>
    </div>
  );
};

export default SpecialInstTab;
